/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendMonthlyTransactionsToAdminCommand } from '../../models/send-monthly-transactions-to-admin-command';
import { Success } from '../../models/success';

export interface SendMonthlyTransactionsToAdminAsync$Params {
      body?: SendMonthlyTransactionsToAdminCommand
}

export function sendMonthlyTransactionsToAdminAsync(http: HttpClient, rootUrl: string, params?: SendMonthlyTransactionsToAdminAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendMonthlyTransactionsToAdminAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendMonthlyTransactionsToAdminAsync.PATH = '/api/report/admin/monthly-transactions';
